import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import Contract, { ContractType } from "domain/contract";
import { ContractsLoaded, ContractAdded, ContractUpdated, ContractsAdded } from "./contracts.actions";
import ContractCollection from "features/contracts/contractCollection";

export default class ContractReducer extends ReducerBase<ContractCollection> {

    constructor() {
        super();
        this.addHandler(ContractsLoaded.EventName, this.handleContractsLoaded);
        this.addHandler(ContractAdded.EventName, this.handleContractAdded);
        this.addHandler(ContractUpdated.EventName, this.handleContractUpdated);
        this.addHandler(ContractsAdded.EventName, this.handleContractsAdded);
    }

    handleContractsLoaded(state: ContractCollection = initialState.contracts, event: ContractsLoaded): ContractCollection {
        const contracts = { ...state };
        contracts[event.contractType as number] = event.contracts;
        return contracts;
    }

    handleContractAdded(state: ContractCollection, event: ContractAdded): ContractCollection {
        const contracts = { ...state };
        addOrUpdate(contracts, event.contract.contractType, event.contract);
        return contracts;
    }

    handleContractsAdded(state: ContractCollection, event: ContractsAdded): ContractCollection {
        const contracts = { ...state };
        event.contracts.forEach(c => addOrUpdate(contracts, c.contractType, c));
        return contracts;
    }

    handleContractUpdated(state: ContractCollection, event: ContractUpdated): ContractCollection {
        const contracts = { ...state };
        addOrUpdate(contracts, event.contract.contractType, event.contract);
        return contracts;
    }

    handleDefault(state: ContractCollection = initialState.contracts): ContractCollection {
        return state;
    }
}

function addOrUpdate(collection: ContractCollection, type: ContractType, contract: Contract) {
    rebuildContractList(collection, type, contracts => {
        let exists = false;
        const newContracts = contracts.map(m => {
            if (m.id === contract.id) {
                exists = true;
                return contract;
            }
            return m;
        });

        if (!exists) newContracts.push(contract);

        return newContracts;
    })
}

function rebuildContractList(collection: ContractCollection, type: ContractType, handler: ((contracts: Contract[]) => Contract[])) {
    let contracts = collection[type as number];

    if (contracts === undefined) {
        contracts = {
            data: [],
            totalCount: 0
        };
    }

    const newData = handler(contracts.data);
    collection[type as number] = {
        data: newData,
        totalCount: newData.length
    }
}